import { useCallback } from 'react';
import { useActions } from 'lib/hooks';
import * as track from 'lib/gaTracking/crossPageEvents';
import { downloadInvoiceErrorModalProps } from './DownloadInvoiceErrorModal';

export const useDownloadInvoiceErrorModal = () => {
  const actions = useActions();

  return useCallback(() => {
    track.invoiceDownloadFailedModalOpened();
    actions.modal.setupModal({
      ...downloadInvoiceErrorModalProps,
      isOpen: true,
      onClose: ({ actionButtonClicked }) => {
        track.invoiceDownloadFailedModalClosed(actionButtonClicked);
      },
    });
  }, [actions.modal]);
};
